import lang from "@/views/modules/Applications/language/en";
let metaList = [
    /* {
        label: lang.LBL_APPLICATION_NO,
        link: true,
        columnName: 'app_no',
    }, */
    {
        label: lang.LBL_PROJECT_TITLE,
        link: false,
        columnName: 'application_title',
    },
    {
        label: lang.LBL_SCHEME_TYPE,
        link: false,
        columnName: 'opportunity_type',
    },
    {
        label: lang.LBL_FUNDER,
        link: false,
        columnName: 'opportunity_funder',
    },
    {
        label: lang.LBL_OPPORTUNITY_BY,
        link: false,
        columnName: 'op_created_by',
    },
    {
        label: lang.LBL_STAGE,
        link: false,
        columnName: 'status',
    },
];
const link_list = {
    routePath: 'applications',
    title: 'Active Applications',
    customDashlet: 'Open',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }